import { useSelector, useDispatch } from 'react-redux'
import { setProgressionLevel, setProgressionLevelScore } from 'redux/slices/generator'

export default function ProgressionLevelInput() {

    const dispatch = useDispatch()

    const progressionLevel = useSelector((state) => state.generator.inputs.progressionLevel)
    const progressionLevelScore = useSelector((state) => state.generator.inputs.progressionLevelScore)

    const progressionLevelOptions = [
        {
            level: 0,
            name: 'Beginner',
            color: 'bg-orange-100',
            rangeText: '(0 - 208)',
        },
        {
            level: 1,
            name: 'Foundational',
            color: 'bg-orange-200',
            rangeText: '(208 - 417)',
        },
        {
            level: 2,
            name: 'Intermediate',
            color: 'bg-orange-300',
            rangeText: '(417 - 782)',
        },
        {
            level: 3,
            name: 'Progressed',
            color: 'bg-orange-400',
            rangeText: '(782 - 938)',
        },
        {
            level: 4,
            name: 'Advanced',
            color: 'bg-orange-500',
            rangeText: '(938 - 1042)',
        },
    ]

    const AlignProgressionValues = (source, value) => {
        switch (source) {
            case 'level':
                dispatch(setProgressionLevel(value))

                switch (value) {
                    case 0:
                        dispatch(setProgressionLevelScore(0))
                        break
                    case 1:
                        dispatch(setProgressionLevelScore(208))
                        break
                    case 2:
                        dispatch(setProgressionLevelScore(417))
                        break
                    case 3:
                        dispatch(setProgressionLevelScore(782))
                        break
                    case 4:
                        dispatch(setProgressionLevelScore(938))
                        break
                    default:
                        dispatch(setProgressionLevelScore(0))
                }

                break

            case 'score':
                dispatch(setProgressionLevelScore(value))

                if (0 <= value && value < 208) dispatch(setProgressionLevel(0))
                else if (208 <= value && value < 417) dispatch(setProgressionLevel(1))
                else if (417 <= value && value < 782) dispatch(setProgressionLevel(2))
                else if (782 <= value && value < 938) dispatch(setProgressionLevel(3))
                else if (782 <= value) dispatch(setProgressionLevel(4))

                break

            default:
                console.error(source + ' is not a valid progression source!!')
        }
    }
    
    return (
        <div className="flex items-center gap-x-2">
            
            <div className="flex-grow flex text-center rounded overflow-hidden">
                    {progressionLevelOptions.map((option) => (
                    <div
                        key={option.level}
                        className={`flex-grow py-2 cursor-pointer hover:opacity-80 ${option.color} ${option.level === progressionLevel ? 'border-2 border-gray-600 font-semibold' : ''}`}
                        onClick={() => AlignProgressionValues('level', option.level)}
                    >
                        <div>{option.name}</div>
                        <div className="text-xs">{option.rangeText}</div>
                    </div>
                ))}
            </div>

            <input
                min={0}
                max={1042}
                type="number"
                name="progressionLevelScore"
                id="progressionLevelScore"
                className="px-4 py-2 rounded-md ring-1 ring-gray-300"
                value={progressionLevelScore}
                onChange={(event) => AlignProgressionValues('score', parseInt(event.target.value))}
            />

        </div>
    )
}   